export type SearchValue = {
  name?: string;
  organizationId?: string | null | undefined;
  personnelNumber?: string | null;
  contributorTypeId?: string | null;
  agencyId?: string | null;
  responded?: boolean | null;
  hasResponded?: boolean | null;
  hasContributed?: boolean | null;
  methodOfGivingId?: string | null;
};

export interface State {
  searchValue: SearchValue;
  isActive: boolean;
}

export const SearchDefaultValue: SearchValue = {
  name: "",
  organizationId: null,
};
